<template>
  <div>
    <div :style="{width:windowWidth+'px',height:conHeight+'px',backgroundColor: designCache.bgColor,backgroundImage: designCache.bgImg ? 'url('+image(designCache.bgImg)+')':'none'}"
         style="background-size:100% 100%;background-color: #2b3340;overflow: hidden">
      <div :style="{width:windowWidth+'px',height:conHeight+'px',transform: 'scale('+containerScale+')'}"
           style="position:relative;transform-origin:0 0;">
        <transition-group appear name="bounce">
          <div v-for="item in designCache.components" :key="item.id"
               :style="{width:Math.round(item.cptWidth)+'px',  height:Math.round(item.cptHeight)+'px',  top:Math.round(item.cptY)+'px', left:Math.round(item.cptX)+'px', zIndex:item.cptZ}"
               style="position: absolute;">
            <component :is="item.cptKey" :height="Math.round(item.cptHeight)" :option="item.cptOption" :width="Math.round(item.cptWidth)" @reload="loadCacheData"/>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import {image} from "@/utils/Tool";
import {getAction} from "@api/manage";
import CptImage from "@/components/element/cpt-image";
import CptDataVBorder from "@/components/dataV/cpt-dataV-border";
import CptButton from "@/components/element/cpt-button";
import CptText from "@/components/element/cpt-text";
import CptCarousel from "@/components/element/cpt-carousel";
import CptDataVDecoration from "@/components/dataV/cpt-dataV-decoration";
import CptDataVDigitalFlop from "@/components/dataV/cpt-dataV-digitalFlop";
import CptDataVPercentPond from "@/components/dataV/cpt-dataV-percentPond";
import CptNum from "@/components/element/cpt-num";
import CptRectNum from "@/components/element/cpt-rect-num";
import CptChartClock from "@/components/echarts/cpt-chart-clock";
import CptChartColumn from "@/components/echarts/cpt-chart-column";
import CptChartGauge from "@/components/echarts/cpt-chart-gauge";
import CptChartMapGc from "@/components/echarts/cpt-chart-map-gc";
import CptChartMapMigrate from "@/components/echarts/cpt-chart-map-migrate";
import CptIframe from "@/components/element/cpt-iframe";
import CptChartTdColumn from "@/components/echarts/cpt-chart-td-column";
import CptChartPie from "@/components/echarts/cpt-chart-pie";
import CptDataVScrollTable from "@/components/dataV/cpt-dataV-scrollTable";
import CptDataVScrollList from "@/components/dataV/cpt-dataV-scrollList";
import CptDataVWaterLevel from "@/components/dataV/cpt-dataV-waterLevel";
import CptChartLine from "@/components/echarts/cpt-chart-line";
import CptDataVActiveRing from "@/components/dataV/cpt-dataV-activeRing";
import CptScrollTable from "@/components/element/cpt-scroll-table";

export default {
  name: "BigScreen",
  components: {
    CptScrollTable,
    CptDataVActiveRing,
    CptChartLine,
    CptDataVWaterLevel,
    CptDataVScrollList,
    CptDataVScrollTable,
    CptChartPie,
    CptChartTdColumn,
    CptIframe,
    CptChartMapMigrate,
    CptChartMapGc,
    CptChartGauge,
    CptChartColumn,
    CptChartClock,
    CptRectNum,
    CptNum,
    CptDataVPercentPond,
    CptDataVDigitalFlop,
    CptDataVDecoration,
    CptCarousel,
    CptText,
    CptButton,
    CptDataVBorder,
    CptImage,
  },
  provide() {
    return {
      queryParam: this.param
    };
  },
  data() {
    return {
      param: {},
      designCache: {},
      windowWidth: 0,
      windowHeight: 0,
      conHeight: 0,
      containerScale: 1,
      authCodeDialogVisible: false,
      viewCode: '',
      url: {
        loadDesign: '/base/dataScreen/view'
      }
    }
  },
  mounted() {
    const that = this;
    that.loadCacheData();
    window.onresize = () => {
      return (() => {
        that.loadSize()
      })();
    };
  },
  methods: {
    image,
    loadCacheData() {
      const that = this;
      const id = this.$route.params.id;
      if (!id) {
        this.$message.error('id错');
        return;
      }
      getAction(this.url.loadDesign, {id}).then(res => {
        if (res.success) {
          that.param.orderNoticeId = res.result.paramOrderNoticeId ? res.result.paramOrderNoticeId : ''
          that.param.organizationId = res.result.paramOrganizationId ? res.result.paramOrganizationId : ''
          that.loadDesign(res.result.reportDesign);
        }
      })
    },
    loadDesign(designStr) {
      let design = JSON.parse(designStr)
      document.title = design.title;
      this.designCache = design;
      this.loadSize();
    },
    loadSize() {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowHeight = document.documentElement.clientHeight;
      this.containerScale = Math.round(this.windowWidth / this.designCache.scaleX * 100) / 100
      this.conHeight = this.designCache.scaleY
      console.log(this.windowWidth, this.containerScale)
    },
  }
}
</script>

<style scoped>
.bounce-enter-active {
  transition: all 1s;
  /*animation: bounce-in 1s;*/
}

.bounce-enter {
  opacity: 0;
  transform: scale(.5);
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
